import { render } from "./forgotten-password.vue?vue&type=template&id=9466f5ea"
import script from "./forgotten-password.js?vue&type=script&lang=js&external"
export * from "./forgotten-password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__